module.exports = __webpack_public_path__ + "assets/female.a2e969a4.png";